(function () {
    var armed = 0;

    // Línea de confianza bajo el botón de BOGOS
    function addTrust() {
      var footer = document.querySelector('.bogos-bundles-quantity-break-widget-footer');
      if (footer && !footer.querySelector('.apih-cro-trust')) {
        var d = document.createElement('div');
        d.className = 'apih-cro-trust';
        d.textContent = 'Envío gratis 24/48h · Devolución 30 días';
        footer.appendChild(d);
      }
    }

    // Texto del botón de BOGOS: "Añadir al carrito · precio de la opción elegida"
    function syncBtn() {
      var w = document.querySelector('.bogos-bundles-quantity-break-widget');
      if (!w) return;
      var btn = w.querySelector('.bogos-bundles-quantity-break-button-add');
      if (!btn) return;
      var sel = w.querySelector('.bogos-bundle-quantity-break_item-container input:checked');
      var box = sel && sel.closest('.bogos-bundle-quantity-break_item-container');
      var priceEl = box && box.querySelector('.bogos-bundle-quantity-break-item-discount-price');
      var price = priceEl ? priceEl.textContent.trim() : '';
      var txt = 'Añadir al carrito' + (price ? ' · ' + price : '');
      if (btn.textContent.trim() !== txt) btn.textContent = txt;
      if (!btn.dataset.apihObs) {
        btn.dataset.apihObs = '1';
        new MutationObserver(function () { setTimeout(syncBtn, 0); }).observe(btn, { childList: true, characterData: true, subtree: true });
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.bogos-bundles-quantity-break-widget')) setTimeout(function () { syncBtn(); enrich(); }, 50);
    });

    // Kits / productos sin selector de packs: misma línea de confianza bajo el botón del tema
    function syncGuarantee() {
      if (document.querySelector('.bogos-bundles-quantity-break-widget')) return;
      document.querySelectorAll('.product-form .product-guarantee--text').forEach(function (el) {
        var t = 'Envío gratis 24/48h · Devolución 30 días';
        if (el.textContent.trim() !== t) el.textContent = t;
      });
    }


    // Precio por unidad y ahorro en euros en cada opción
    function num(t) { var m = (t || '').replace(/[^0-9,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.'); return parseFloat(m); }
    function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
    function enrich() {
      document.querySelectorAll('.bogos-bundle-quantity-break_item-container').forEach(function (box) {
        var titleEl = box.querySelector('.bogos-bundle-quantity-break-title');
        var priceEl = box.querySelector('.bogos-bundle-quantity-break-item-discount-price');
        var origEl = box.querySelector('.bogos-bundle-quantity-break-item-original-price');
        if (!titleEl || !priceEl) return;
        var m = titleEl.textContent.match(/(\d+)\s*unidad/i);
        var qty = m ? parseInt(m[1], 10) : 1;
        var price = num(priceEl.textContent), orig = origEl ? num(origEl.textContent) : NaN;
        var priceWrap = box.querySelector('.bogos-bundle-quantity-break-item-price');
        if (qty > 1 && priceWrap && !isNaN(price)) {
          var u = priceWrap.querySelector('.apih-unit');
          if (!u) { u = document.createElement('span'); u.className = 'apih-unit'; priceWrap.appendChild(u); }
          var ut = fmt(price / qty) + '/ud';
          if (u.textContent !== ut) u.textContent = ut;
        }
        var info = box.querySelector('.bogos-bundle-quantity-break-main-info');
        if (qty > 1 && info && !isNaN(orig) && orig > price) {
          var s = info.querySelector('.apih-save');
          if (!s) { s = document.createElement('span'); s.className = 'apih-save'; info.appendChild(s); }
          var st = 'Ahorras ' + fmt(orig - price);
          if (s.textContent !== st) s.textContent = st;
        }
      });
    }


    // Galería móvil: la altura sigue a la foto/vídeo visible
    function initAdaptiveGallery() {
      var list = document.querySelectorAll('.product__images--mobile-slider .product__slides');
      list.forEach(function (el) {
        if (el.dataset.apihAdaptive) return;
        el.dataset.apihAdaptive = '1';
        var raf = 0;
        function current() {
          var slides = el.querySelectorAll('.product__slide');
          var best = null, bestD = Infinity, left = el.getBoundingClientRect().left;
          slides.forEach(function (s) { var d = Math.abs(s.getBoundingClientRect().left - left); if (d < bestD) { bestD = d; best = s; } });
          return best;
        }
        function update() {
          raf = 0;
          if (window.innerWidth > 749) { el.style.height = ''; return; }
          var s = current();
          if (s && s.offsetHeight) el.style.height = s.offsetHeight + 'px';
        }
        function schedule() { if (!raf) raf = requestAnimationFrame(update); }
        el.addEventListener('scroll', function () { clearTimeout(el._apihT); el._apihT = setTimeout(schedule, 80); }, { passive: true });
        window.addEventListener('resize', schedule);
        if (window.ResizeObserver) { var ro = new ResizeObserver(schedule); el.querySelectorAll('.product__slide').forEach(function (s) { ro.observe(s); }); }
        el.querySelectorAll('img,video').forEach(function (m) { m.addEventListener('load', schedule); m.addEventListener('loadedmetadata', schedule); });
        schedule();
      });
    }

    // Barra fija de compra: aparece al pasar el botón principal y añade la opción ELEGIDA en el selector
    function initSticky() {
      if (document.querySelector('.apih-sticky')) return;
      var bogosBtn = document.querySelector('.bogos-bundles-quantity-break-button-add');
      var themeBtn = document.querySelector('.product__content .product-form button[data-add-to-cart]');
      if (!bogosBtn && document.querySelector('#bogos-bundle-quantity-break-view') && tries < 16) return; // esperar a que BOGOS pinte el selector
      var target = (bogosBtn && bogosBtn.offsetHeight) ? bogosBtn : (themeBtn && themeBtn.offsetHeight ? themeBtn : null);
      if (!target) return;
      var isBogos = target === bogosBtn;
      var title = '';

      var bar = document.createElement('div');
      bar.className = 'apih-sticky';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="apih-sticky__inner"><div class="apih-sticky__info"><div class="apih-sticky__title"></div><div class="apih-sticky__meta"><span class="apih-sticky__sel"></span></div></div><button type="button" class="apih-sticky__btn">Añadir al carrito</button></div>';
      bar.querySelector('.apih-sticky__title').textContent = title;
      fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r) { return r.json(); }).then(function (p) { if (p && p.title) bar.querySelector('.apih-sticky__title').textContent = p.title; }).catch(function () {});
      if (isBogos) {
        var ch = document.createElement('button');
        ch.type = 'button'; ch.className = 'apih-sticky__change'; ch.textContent = 'Cambiar';
        ch.addEventListener('click', function () { var w = document.querySelector('.bogos-bundles-quantity-break-widget'); if (w) w.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
        bar.querySelector('.apih-sticky__meta').appendChild(ch);
      }
      document.body.appendChild(bar);

      function selText() {
        if (isBogos) {
          var sel = document.querySelector('.bogos-bundle-quantity-break_item-container input:checked');
          var box = sel && sel.closest('.bogos-bundle-quantity-break_item-container');
          if (!box) return '';
          var t = box.querySelector('.bogos-bundle-quantity-break-title');
          var p = box.querySelector('.bogos-bundle-quantity-break-item-discount-price');
          return (t ? t.textContent.trim() : '') + (p ? ' · ' + p.textContent.trim() : '');
        }
        var pr = document.querySelector('.product__content [data-product-price]');
        return pr ? pr.textContent.trim() : '';
      }
      function refresh() { var s = bar.querySelector('.apih-sticky__sel'), t = selText(); if (s.textContent !== t) s.textContent = t; }
      refresh();
      document.addEventListener('change', function () { setTimeout(refresh, 60); });

      bar.querySelector('.apih-sticky__btn').addEventListener('click', function () {
        var b = isBogos ? document.querySelector('.bogos-bundles-quantity-break-button-add') : document.querySelector('.product__content .product-form button[data-add-to-cart]');
        if (!b) return;
        this.disabled = true; this.textContent = 'Añadiendo…';
        var me = this;
        b.click();
        setTimeout(function () { me.disabled = false; me.textContent = 'Añadir al carrito'; }, 4000);
      });

      function setVisible(v) {
        bar.classList.toggle('is-visible', v);
        bar.setAttribute('aria-hidden', v ? 'false' : 'true');
        document.body.classList.toggle('apih-sticky-on', v);
      }
      function check() {
        var r = target.getBoundingClientRect();
        setVisible(r.bottom < 0);
      }
      window.addEventListener('scroll', function () { refresh(); check(); }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }

    var tries = 0, iv = setInterval(function () { addTrust(); syncBtn(); syncGuarantee(); enrich(); initAdaptiveGallery(); initSticky(); if (++tries > 40) clearInterval(iv); }, 250);

    // Al añadir con BOGOS, llevar al carrito (en vez de no dar feedback)
    document.addEventListener('click', function (e) {
      if (e.target.closest('.bogos-bundles-quantity-break-button-add')) {
        armed = Date.now();
        e.target.closest('.bogos-bundles-quantity-break-button-add').classList.add('is-loading');
      }
    }, true);
    function isAdd(url) { return armed && Date.now() - armed < 8000 && /\/cart\/add/.test(String(url)); }
    function go() { armed = 0; window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart'; }

    var of = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = of.apply(this, arguments);
      if (isAdd(url)) p.then(function (r) { if (r.ok) setTimeout(go, 300); });
      return p;
    };
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (isAdd(url)) this.addEventListener('load', function () { if (this.status < 400) setTimeout(go, 300); });
      return oo.apply(this, arguments);
    };

    // Barra fija de compra: subir al selector en vez de añadir 1 unidad
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add-to-cart-bar]');
      var w = document.querySelector('.bogos-bundles-quantity-break-widget');
      if (b && w && w.offsetHeight) {
        e.preventDefault(); e.stopImmediatePropagation();
        w.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  })();
